import { toastError } from "../redux/guest-slices/other.slice"
import { jwtDecode } from "jwt-decode"
import { Cookies } from "react-cookie"

const ACCESS_TOKEN_KEY = "token"
const TOKEN_MAX_AGE = 24 * 60 * 60

class TokenServices {
  dispatch = null
  cookieServices = new Cookies()
  constructor(dispatch) {
    this.dispatch = dispatch
  }

  // -------- Set token in cookies --------
  setAccessToken(token) {
    this.cookieServices.set(ACCESS_TOKEN_KEY, token, { maxAge: TOKEN_MAX_AGE, path: "/" })
  }

  // -------- Get token --------
  getAccessToken(silent = false) {
    try {
      const token = this.cookieServices.get(ACCESS_TOKEN_KEY)
      const { exp } = jwtDecode(token)
      const isExpired = exp * 1000 < Date.now()
      if (isExpired) {
        if (!silent) this.dispatchError()
        return null
      }

      return token
    } catch (error) {
      if (!silent)
        this.dispatchError()
      return null
    }
  }

  // -------- Is logged in --------
  isLoggedIn() {
    return !!this.getAccessToken(true)
  }

  // -------- Remove token --------
  removeAccessToken() {
    return this.cookieServices.remove(ACCESS_TOKEN_KEY, { path: "/" })
  }

  // -------- Dispatch error --------
  dispatchError() {
    console.error("Token expired. Please login again!")
    if (this.dispatch)
      this.dispatch(toastError("Token expired. Please login again!"))
    return null
  }
}

export default TokenServices